import { createMainAppMicroserviceInstance } from '@servicetitan/cp-api';
import { inject, injectable, optional } from '@servicetitan/react-ioc';
import { BrandData, PortalBranding } from './portal-branding.api';

@injectable()
export class BrandingApi {
    private api: PortalBranding;

    constructor(@inject('baseUrl') @optional() baseUrl?: string) {
        this.api = new PortalBranding(
            createMainAppMicroserviceInstance('/v1/customerportal2/branding', '/api/cp/branding'),
            baseUrl
        );
    }

    async getInvoice(encryptedId: string): Promise<BrandData> {
        const brand = (await this.api.getBrandingByInvoice(encryptedId)).data;
        return { ...brand, logoUrl: this.removeQueryParameters(brand.logoUrl) };
    }
    async getProposal(encryptedId: string): Promise<BrandData> {
        const brand = (await this.api.getBrandingByProposal(encryptedId)).data;
        return { ...brand, logoUrl: this.removeQueryParameters(brand.logoUrl) };
    }
    async getServiceAgreement(serviceAgreementId: number): Promise<BrandData> {
        const brand = (await this.api.getBrandingByServiceAgreement(serviceAgreementId)).data;
        return { ...brand, logoUrl: this.removeQueryParameters(brand.logoUrl) };
    }

    /*
     * Remove query parameters which affect logo dimensions, but keep
     * tenant routing and default-image fallback params intact.
     */
    private removeQueryParameters(logoUrl: string | undefined): string | undefined {
        if (!logoUrl) {
            return undefined;
        }
        try {
            const url = new URL(logoUrl);
            url.searchParams.delete('size');
            url.searchParams.delete('height');
            return url.toString();
        } catch {
            return logoUrl;
        }
    }
}
